import React from 'react'
import { css } from 'styled-components'
import { space, fontSizes, palette } from '../../../utils/tokens'

const FormQuestion = ({
  title,
  description,
  className
}) => {
  return (
    <div
      css={css({
        marginBottom: `${space[4]}px`,
      })}
      className={className}
    >
      <h5
        css={css({
          fontSize: fontSizes[3],
          fontWeight: `bold`,
          marginBottom: `${space[2]}px`,
        })}
      >
        {title}
      </h5>
      <p
        css={css({
          color: `${palette.grey[70]}`
        })}
      >{description}</p>
    </div>
  )
}

export default FormQuestion